import React from "react";
import { Button, Row, Col, Spin } from "antd";
import {
  HomeOutlined,
  ClockCircleOutlined,
  UserOutlined,
  SolutionOutlined,
  TeamOutlined,
  ShopOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./QuickSearchComponent.css";
import { theme } from "../../../utils/theme";
import useCommonsService from "../../../services/useCommonsService";
import PageRoutes from "../../../utils/routes";

const icons = [
  <SolutionOutlined />,
  <ClockCircleOutlined />,
  <UserOutlined />,
  <HomeOutlined />,
  <TeamOutlined />,
  <ShopOutlined />,
];

const QuickSearchComponent = () => {
  const navigate = useNavigate();
  const { useGetLabelKeys } = useCommonsService();
  const { data: labelKeys, isLoading: isLabelKeysLoading } = useGetLabelKeys();

  const handleQuickSearch = (labelKey) => {
    navigate(PageRoutes.listings, {
      state: { labelKey: labelKey },
    });
  };

  if (isLabelKeysLoading) {
    return <Spin spinning={true}></Spin>;
  }

  const labelKeysToShow = [...labelKeys.slice(0, 5), labelKeys[7]];

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: theme.backgroundGrayColor,
        padding: 20,
      }}>
      <div className="quick-search-container">
        <Row gutter={[16, 16]}>
          {labelKeysToShow.map((item, index) => (
            <Col
              key={index}
              xs={24}
              sm={12}
              md={8}
              lg={8}
              xl={8}
              className="quick-search-col">
              <Button
                type="default"
                className="quick-search-button"
                block
                onClick={() => {
                  handleQuickSearch(item.value);
                }}>
                <span className="quick-search-icon">{icons[index]}</span>
                <span className="quick-search-label">{item.label}</span>
              </Button>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default QuickSearchComponent;
